var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"ok-only":"","id":"match-details-modal","title":"Match Details"}},[_c('div',[_vm._v(_vm._s(_vm.matchDetails))])])
}
var staticRenderFns = []

export { render, staticRenderFns }